import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.restoreScroll = this.restoreScroll.bind(this)
  }

  disconnect() {
    this.removeRestoreListeners()
  }

  visit(event) {
    event.preventDefault()

    this.scrollPosition = {x: window.scrollX, y: window.scrollY}
    this.addRestoreListeners()

    Turbo.visit(this.urlValue || this.element.href, {
      action: "replace"
    })
  }

  addRestoreListeners() {
    this.removeRestoreListeners()
    document.addEventListener("turbo:render", this.restoreScroll)
    document.addEventListener("turbo:load", this.restoreScroll)
  }

  removeRestoreListeners() {
    document.removeEventListener("turbo:render", this.restoreScroll)
    document.removeEventListener("turbo:load", this.restoreScroll)
  }

  restoreScroll() {
    if (!this.scrollPosition) return

    const {x, y} = this.scrollPosition
    this.scrollPosition = null
    this.removeRestoreListeners()

    requestAnimationFrame(() => {
      window.scrollTo({left: x, top: y, behavior: "instant"})
    })
  }
}
